import { curry, property } from 'lodash-es';

export const propEq = curry(
  (prop, value, obj) => value === property(prop)(obj)
);
